import { withSearchParams } from "@/libs/links";
import { Toast, Toaster } from "@blueprintjs/core";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { queryToString } from "utils";

export const PageToast = () => {
  const router = useRouter();
  const params = new URLSearchParams(queryToString(router.query));
  const [errMessage, setErrMessage] = useState<string>(null);
  const [successMessage, setSuccessMessage] = useState<string>(null);

  useEffect(() => {
    if (router.query["error_msg"]) {
      setErrMessage(String(router.query["error_msg"]));
      params.delete("error_msg");
      router.push(
        withSearchParams(router.pathname, params),
        {},
        {
          shallow: true,
        }
      );
    }
  }, [router.query["error_msg"]]);

  useEffect(() => {
    if (router.query["success_msg"]) {
      setSuccessMessage(String(router.query["success_msg"]));
      params.delete("success_msg");
      router.push(
        withSearchParams(router.pathname, params),
        {},
        {
          shallow: true,
        }
      );
    }
  }, [router.query["success_msg"]]);

  return (
    <Toaster>
      {errMessage && (
        <Toast
          intent="warning"
          icon="warning-sign"
          message={errMessage}
          onDismiss={() => setErrMessage(null)}
        />
      )}
      {successMessage && (
        <Toast
          intent="success"
          icon="thumbs-up"
          message={successMessage}
          onDismiss={() => setSuccessMessage(null)}
        />
      )}
    </Toaster>
  );
};
